export type EventImportantDetailSlug =
  | 'giftcard'
  | 'about'
  | 'steps'
  | 'included'
  | 'bring'
  | 'people'
  | 'courseTarget'

export const EVENT_IMPORTANT_DETAIL_ALL_ITEMS: EventImportantDetailSlug[] = [
  'giftcard',
  'about',
  'steps',
  'included',
  'bring',
  'people',
  'courseTarget',
]
